<template>
  <div :class="['callout-bubble-wrapper', wrapperClasses]">
    <label>
      {{label}}
      <span v-if="labelDetail" class="label-detail"> {{labelDetail}}</span>
    </label>
    <div :class="['callout', calloutClasses]">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalloutBubble',

  props: {
    calloutClasses: String,
    label: String,
    labelDetail: String,
    wrapperClasses: String,
  },
}
</script>
